import type {
    RemoveCommerceCartLineRequest,
    RemoveCommerceCartLineResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const removeCommerceCartLineOperation = defineCommerceOperation<
    RemoveCommerceCartLineRequest,
    RemoveCommerceCartLineResponse
>("commerce.cart.lines.remove");
